<div class="modal modal-buttons modal-right show-modal">
  <div class="modal-container">
    <div class="titulo-modal">
      <span class="modal-close" mat-dialog-close></span>
      <h2>{{titulo}}</h2>
    </div>
    <div class="modal-content-docs">
      <app-add-docs-data-grid [documentos]="data.documentos" [oldDocsSelected]="data.objetoEnvio.tiposDocumento" [seleccion]="seleccion" (seleccionDocs)="seleccionarDocs($event)"></app-add-docs-data-grid>
    </div>
    <div class="modal-buttons-docs">
      <app-boton-accion mat-button (botonClicked)="guardarDocsExistentes()" [icono]="iconoBoton" [titulo]="textoBoton" [id]="textoBoton">
      </app-boton-accion>
    </div>
  </div>
</div>
